module.exports = __webpack_public_path__ + "static/media/3.12e04a68.png";